<template>
    
            <v-card style="min-height: 85vh !important;">
                <v-card-title class="pt-7 pb-7">Nouvel Avis</v-card-title>
                <v-card-text class="pt-7 pb-7">
                        <v-snackbar
                            v-model="snackbar"
                            :color="color"
                            right
                            top
                            multi-line
                            app
                        >
                            {{snackbarText}}
                            <v-btn
                            text
                            dark
                            @click="snackbar = false"
                            >
                            Fermer
                            </v-btn>
                        </v-snackbar>
                        <v-tabs
                        hide-slider
                        v-model="tab"
                        background-color="transparent"
                        grow
                        >
                        <v-tab
                            v-for="item in itemsTabs"
                            class="avis-tab"
                            :key="item"
                        >
                            {{ item }}
                        </v-tab>
                        </v-tabs>
                        <v-tabs-items v-model="tab">
                        <v-tab-item>
                            <v-form v-model="valid">
                            <v-row class="mt-5">
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        dense
                                        v-model="currentDossier.numdossier"
                                        label="Référence"
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Avis N°"
                                        v-model="avisTmp.num_avis"
                                        dense
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Type Dossier"
                                        v-model="currentDossier.type"
                                        dense
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Classe Dossier"
                                        v-model="currentDossier.classe"
                                        dense
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field
                                        label="Date Avis"
                                        dense
                                        v-model="todayDate"
                                        :value=todayDate
                                        disabled
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <template v-if="currentDossier.classe !== 'Aérien'">
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            v-model=currentDossier.escale
                                            label="Escale"
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            v-model=currentDossier.voyage
                                            label="Voyage"
                                            dense
                                            disabled
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Consignataire"
                                            dense
                                            disabled
                                            v-model=currentDossier.consig
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Armateur Navire"
                                            v-model=currentDossier.armateur
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Navire"
                                            v-model=currentDossier.navire
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Date d'embarquement"
                                            dense
                                            :value="currentDossier.from_date | formatDate"
                                            disabled
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Port d'embarquement"
                                            v-model=currentDossier.port_from
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Date de débarquement"
                                            :value="currentDossier.to_date | formatDate"
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Port de débarquement"
                                            v-model=currentDossier.port_to
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="N°LTA"
                                            dense
                                            disabled
                                            v-model=currentDossier.num_lta
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Compagnie Aérienne"
                                            dense
                                            disabled
                                            v-model=currentDossier.compagnie_aerienne
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="N°Vol"
                                            dense
                                            disabled
                                            v-model=currentDossier.num_vol
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Date de Départ"
                                            dense
                                            :value="currentDossier.from_date | formatDate"
                                            disabled
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Aéroport de Départ"
                                            v-model=currentDossier.aeroport_depart
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Date d'Arrivée"
                                            :value="currentDossier.to_date | formatDate"
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Aéroport d'Arrivée"
                                            v-model=currentDossier.aeroport_arrivee
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                </template>
                                <template v-if="currentDossier.classe == 'Groupage'">
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Type Conteneur"
                                            v-model=currentDossier.conteneur_type
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="N° Conteneur"
                                            v-model=currentDossier.conteneur_num
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="N° Escale Magasin"
                                            v-model=currentDossier.num_escale_magasin
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="3" md="2">
                                        <v-text-field
                                            label="Date de Dépotage"
                                            :value="currentDossier.date_depotage | formatDate" 
                                            disabled
                                            dense
                                            outlined
                                        ></v-text-field>
                                    </v-col>
                                </template>
                            </v-row>
                            <v-row>
                                <v-col cols="12" sm="4" md="4" v-if="currentDossier.classe === 'Groupage'">
                                    <v-text-field
                                        label="Valeur"
                                        dense
                                        v-model="avisTmp.valeur"
                                        :rules="infoRules"
                                        outlined
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4" v-if="currentDossier.classe === 'Groupage'">
                                    <v-text-field
                                        label="Bureau"
                                        dense
                                        v-model="avisTmp.bureau"
                                        :rules="infoRules"
                                        outlined
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4" v-if="currentDossier.classe === 'Groupage'">
                                    <v-text-field
                                        label="Code Magasin"
                                        dense
                                        v-model="avisTmp.code_magasin"
                                        :rules="infoRules"
                                        outlined
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-autocomplete
                                        label="Client"
                                        dense
                                        v-model="avisTmp.client_id"
                                        outlined
                                        :items="clients"
                                        item-text="fullname"
                                        item-value="id"
                                        :rules="infoRules"
                                        required
                                    ></v-autocomplete>
                                </v-col>
                                <v-col v-if="currentDossier.classe !== 'Aérien'" cols="12" sm="4" md="4">
                                    <v-text-field
                                        label="BL"
                                        dense
                                        :rules="infoRules"
                                        v-model="avisTmp.bl"
                                        required
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        label="P/C"
                                        dense
                                        v-model="avisTmp.pc"
                                        :rules="infoRules"
                                        outlined
                                        required
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <v-autocomplete
                                        v-model="avisTmp.correspondant_id"
                                        :items="correspondantList"
                                        item-text="nom"
                                        item-value="id"
                                        outlined
                                        :rules="infoRules"
                                        dense
                                        required
                                        label="Correspondant"
                                    ></v-autocomplete>
                                </v-col>
                                
                                <v-col cols="12" sm="4" md="4">
                                    <v-autocomplete
                                        v-model="avisTmp.agent_id"
                                        :items="agentList"
                                        item-text="nom"
                                        item-value="id"
                                        outlined
                                        required
                                        :rules="infoRules"
                                        dense
                                        label="Agent commercial"
                                    ></v-autocomplete>
                                </v-col>
                                
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        label="Terme"
                                        dense
                                        v-model="avisTmp.terme"
                                        :rules="infoRules"
                                        required
                                        outlined
                                    ></v-text-field>
                                </v-col>
                                <!--<v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        label="Expéditeur"
                                        dense
                                        v-model="avisTmp.expediteur"
                                        outlined
                                        :rules="infoRules"
                                        required
                                    ></v-text-field>
                                </v-col>-->
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field
                                        label="Fournisseur"
                                        dense
                                        v-model="avisTmp.fournisseur"
                                        outlined
                                        :rules="infoRules"
                                        required
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            </v-form>
                        </v-tab-item>
                        <v-tab-item>
                                <v-row class="mt-5">
                                    <v-col cols="12" sm="10" v-if="currentDossier.classe == 'Complet'">
                                        <v-row>
                                            <v-col cols="12" sm="2">
                                                <v-autocomplete
                                                v-model=marchandiseTmp.conttype
                                                :items="conteneurList"
                                                item-text=titre
                                                outlined
                                                dense
                                                label="Type Conteneur"
                                                ></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" sm="2">
                                                <v-text-field
                                                    v-model=marchandiseTmp.cont_numero
                                                    label="Numero Conteneur"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2">
                                            <v-text-field
                                                v-model=marchandiseTmp.rub
                                                label="Rub."
                                                outlined
                                                dense
                                            ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2">
                                                <v-text-field
                                                    v-model=marchandiseTmp.colis
                                                    label="Colis"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2">
                                            <v-text-field
                                                v-model=marchandiseTmp.description
                                                label="Description de la marchandise"
                                                outlined
                                                dense
                                            ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2">
                                                <v-text-field
                                                    v-model=marchandiseTmp.poids
                                                    label="Poids (Kg)"
                                                    type="number"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="10" v-if="currentDossier.classe == 'Groupage'">
                                        <v-row>
                                            <v-col cols="12" sm="2">
                                            <v-text-field
                                                v-model=marchandiseTmp.rub
                                                label="Rub."
                                                outlined
                                                dense
                                            ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2">
                                                <v-text-field
                                                    v-model=marchandiseTmp.colis
                                                    label="Colis"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="4">
                                            <v-text-field
                                                v-model=marchandiseTmp.description
                                                label="Description de la marchandise"
                                                outlined
                                                dense
                                            ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2">
                                                <v-text-field
                                                    v-model=marchandiseTmp.poids
                                                    label="Poids (Kg)"
                                                    type="number"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="2">
                                                <v-text-field
                                                    v-model=marchandiseTmp.volume
                                                    label="Volume"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="10" v-if="currentDossier.classe == 'Aérien'">
                                        <v-row>
                                            <v-col cols="12" sm="3">
                                            <v-text-field
                                                v-model=marchandiseTmp.rub
                                                label="Rub."
                                                outlined
                                                dense
                                            ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                                <v-text-field
                                                    v-model=marchandiseTmp.colis
                                                    label="Colis"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                            <v-text-field
                                                v-model=marchandiseTmp.description
                                                label="Description de la marchandise"
                                                outlined
                                                dense
                                            ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="3">
                                                <v-text-field
                                                    v-model=marchandiseTmp.poids
                                                    label="Poids (Kg)"
                                                    type="number"
                                                    outlined
                                                    dense
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" sm="2" class="text-right pt-6">
                                        <v-btn width="100%" style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" @click="addMarchandise">Ajouter Marchandise</v-btn>
                                    </v-col>

                                </v-row>
                                <v-data-table
                                :headers="headersMarchandises"
                                :items="marchandises"
                                v-if="currentDossier.classe == 'Complet'"
                                >
                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-icon
                                        small
                                        @click="deleteMarchandises(item)"
                                    >
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <template v-slot:[`item.rub`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.rub"
                                    > {{ props.item.rub }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.rub"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.colis`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.colis"
                                    > {{ props.item.colis }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.colis"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.cont_numero`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.cont_numero"
                                    > {{ props.item.cont_numero }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.cont_numero"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.poids`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.poids"
                                    > {{ props.item.poids }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.poids"
                                        type="number"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.description`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.description"
                                    > {{ props.item.description }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.description"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.conttype`]="props">
                                    <v-edit-dialog
                                    large
                                    persistent
                                    @save="updateMarchandiseContType(props.item)"
                                    :return-value.sync="props.item.conttype"
                                    > {{ props.item.conttype }}
                                    <template v-slot:input>
                                            <v-autocomplete
                                        v-model=props.item.conttype
                                        :items="conteneurList"
                                        item-text=titre
                                        single-line
                                        counter
                                        label="Editer"
                                        ></v-autocomplete>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                
                                </v-data-table>
                                <v-data-table
                                :headers="headersMarchandisesGroupage"
                                :items="marchandises"
                                v-if="currentDossier.classe == 'Groupage'"
                                >
                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-icon
                                        small
                                        @click="deleteMarchandises(item)"
                                    >
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <template v-slot:[`item.rub`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.rub"
                                    > {{ props.item.rub }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.rub"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.colis`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.colis"
                                    > {{ props.item.colis }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.colis"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.cont_numero`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.cont_numero"
                                    > {{ props.item.cont_numero }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.cont_numero"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.poids`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.poids"
                                    > {{ props.item.poids }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.poids"
                                        label="Editer"
                                        type="number"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.description`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.description"
                                    > {{ props.item.description }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.description"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.conttype`]="props">
                                    <v-edit-dialog
                                    large
                                    persistent
                                    @save="updateMarchandiseContType(props.item)"
                                    :return-value.sync="props.item.conttype"
                                    > {{ props.item.conttype }}
                                    <template v-slot:input>
                                            <v-autocomplete
                                        v-model=props.item.conttype
                                        :items="conteneurList"
                                        item-text=titre
                                        single-line
                                        counter
                                        label="Editer"
                                        ></v-autocomplete>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                
                                </v-data-table>
                                <v-data-table
                                :headers="headersMarchandisesAerien"
                                :items="marchandises"
                                v-if="currentDossier.classe == 'Aérien'"
                                >
                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-icon
                                        small
                                        @click="deleteMarchandises(item)"
                                    >
                                        mdi-delete
                                    </v-icon>
                                </template>
                                <template v-slot:[`item.rub`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.rub"
                                    > {{ props.item.rub }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.rub"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.colis`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.colis"
                                    > {{ props.item.colis }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.colis"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.cont_numero`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.cont_numero"
                                    > {{ props.item.cont_numero }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.cont_numero"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.poids`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.poids"
                                    > {{ props.item.poids }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.poids"
                                        label="Editer"
                                        type="number"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.description`]="props">
                                    <v-edit-dialog
                                    :return-value.sync="props.item.description"
                                    > {{ props.item.description }}
                                    <template v-slot:input>
                                        <v-text-field
                                        v-model="props.item.description"
                                        label="Editer"
                                        single-line
                                        counter
                                        ></v-text-field>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                <template v-slot:[`item.conttype`]="props">
                                    <v-edit-dialog
                                    large
                                    persistent
                                    @save="updateMarchandiseContType(props.item)"
                                    :return-value.sync="props.item.conttype"
                                    > {{ props.item.conttype }}
                                    <template v-slot:input>
                                            <v-autocomplete
                                        v-model=props.item.conttype
                                        :items="conteneurList"
                                        item-text=titre
                                        single-line
                                        counter
                                        label="Editer"
                                        ></v-autocomplete>
                                    </template>
                                    </v-edit-dialog>
                                </template>
                                
                                </v-data-table>
                        </v-tab-item>
                        <v-tab-item class="mt-5">
                                <v-row>
                                    <v-col cols="12" md="3">
                                        <v-alert
                                        text
                                        class="text-left"
                                        color="info"
                                        >
                                        <div>Pour ajouter une préstation, il suffit d'en cliquer et elle s'ajoutera automatiquement.</div>
                                        </v-alert>
                                        <v-text-field v-model="searchPrest" append-icon="mdi-magnify" label="Rechercher une prestation.." hide-details></v-text-field>
                                        <v-treeview 
                                            style="text-align:left;"
                                            v-model="tree"
                                            :items="items"
                                            activatable
                                            :search="searchPrest"
                                            item-key="id"
                                            open-on-click
                                        >
                                        <template slot="label" slot-scope="{ item }">
                                        <a v-if="item.name !== 'Préstations' && item.name !== 'Fret'" style="width: 100%;display: block;padding: 15px;" @click="selectPrest(item.code_prestation, prestations.length)">{{ item.name }}</a>
                                        <a v-else style="width: 100%;display: block;padding: 15px;">{{ item.name }}</a>
                                        </template>
                                        </v-treeview>
                                    </v-col>
                                    <v-col cols="12" md="9">
                                        <v-data-table
                                        hide-default-footer
                                        :headers="headersPrestations"
                                        :items="prestations"
                                        :items-per-page=100
                                        item-key="key"
                                        >
                                        <template v-slot:[`item.tva`]="props">
                                            
                                            <v-edit-dialog
                                            :return-value.sync="props.item.tva"
                                            large
                                            persistent
                                            >
                                            <div>{{Number(props.item.tva).toFixed(0)}}</div>
                                            <template v-slot:[`input`]>
                                                <div class="mt-4 title">Modifier TVA</div>
                                            </template>
                                            <template v-slot:input>
                                                <v-text-field
                                                v-model="props.item.tva"
                                                label="Edit"
                                                single-line
                                                counter
                                                type="number"
                                                autofocus
                                                ></v-text-field>
                                            </template>
                                            </v-edit-dialog>
                                        </template>

                                        <template v-slot:[`item.devise`]="props">
                                            
                                            <v-edit-dialog
                                            :return-value.sync="props.item.devise"
                                            large
                                            persistent
                                            >
                                            <div>{{props.item.devise}}</div>
                                            <template v-slot:[`input`]>
                                                <div class="mt-4 title">Modifier Devise</div>
                                            </template>
                                            <template v-slot:input>
                                                <v-select label="Devise" v-model="props.item.devise" :items="['TND', 'USD', 'EUR']" autofocus required></v-select>
                                            </template>
                                            </v-edit-dialog>
                                        </template>

                                        <template v-slot:[`item.montantTva`]="props">
                                            {{props.item.montantTva.toFixed(3)}}
                                        </template>

                                        <template v-slot:[`item.description`]="props">
                                            <v-edit-dialog
                                            :return-value.sync="props.item.description"
                                            > {{ props.item.description }}
                                            <template v-slot:input>
                                                <v-text-field
                                                v-model="props.item.description"
                                                label="Edit"
                                                persistent
                                                counter
                                                ></v-text-field>
                                            </template>
                                            </v-edit-dialog>
                                        </template>
                                        <template v-slot:[`item.montant`]="props">
                                            
                                            <v-edit-dialog
                                            :return-value.sync="props.item.montant"
                                            large
                                            persistent
                                            >
                                            <div>{{Number(props.item.montant).toFixed(3)}}</div>
                                            <template v-slot:[`input`]>
                                                <div class="mt-4 title">Modifier montant</div>
                                            </template>
                                            <template v-slot:input>
                                                <v-text-field
                                                v-model="props.item.montant"
                                                label="Editer"
                                                single-line
                                                counter
                                                type="Number"
                                                autofocus
                                                ></v-text-field>
                                            </template>
                                            </v-edit-dialog>
                                        </template>
                                        
                                        <template v-slot:[`item.montantDevise`]="props">
                                            
                                            <v-edit-dialog
                                            :return-value.sync="props.item.montantDevise"
                                            large
                                            persistent
                                            >
                                            <div>{{Number(props.item.montantDevise).toFixed(2)}}</div>
                                            <template v-slot:[`input`]>
                                                <div class="mt-4 title">Modifier Montant Devise</div>
                                            </template>
                                            <template v-slot:input>
                                                <v-text-field
                                                v-model="props.item.montantDevise"
                                                label="Edit"
                                                single-line
                                                counter
                                                type="Number"
                                                autofocus
                                                ></v-text-field>
                                            </template>
                                            </v-edit-dialog>
                                        </template>

                                        <template v-slot:[`item.cour`]="props">
                                            
                                            <v-edit-dialog
                                            :return-value.sync="props.item.cour"
                                            large
                                            persistent
                                            >
                                            <div>{{Number(props.item.cour).toFixed(3)}}</div>
                                            <template v-slot:[`input`]>
                                                <div class="mt-4 title">Modifier Cours</div>
                                            </template>
                                            <template v-slot:input>
                                                <v-text-field
                                                v-model="props.item.cour"
                                                label="Edit"
                                                single-line
                                                counter
                                                type="number"
                                                autofocus
                                                ></v-text-field>
                                            </template>
                                            </v-edit-dialog>
                                        </template>

                                        <template v-slot:[`item.actions`]="{ item }">
                                            <v-icon
                                                small
                                                @click="deletePrestation(item)"
                                            >
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        </v-data-table>



                                        <v-row class="d-flex align-end flex-column mt-5">
                                            <v-col class="mt-auto" cols="12" md="6" style="text-align: right; font-size:16px; line-height:25px">
                                                Montant non taxable : {{totalnt.toFixed(3)}} DT <br>
                                                Montant taxable : {{totalt.toFixed(3)}}  DT <br>
                                                Total TVA : {{totaltva.toFixed(3)}} DT <br>
                                                Timbre Fiscal : {{ Number(avisTmp.timbre).toFixed(3) }} DT <br>
                                                Montant TTC : {{total.toFixed(3)}} DT <br>
                                            </v-col>
                                            <v-col cols="12" md="6" style="text-align: right; font-size:16px; line-height:25px">
                                                <p>Editer le timbre fiscal</p>
                                                <v-text-field
                                                label="Timbre Fiscal"
                                                v-model="avisTmp.timbre"
                                                :rules="infoRules"
                                                type="number"
                                                outlined
                                                required
                                                hide-details
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                        </v-tab-item>
                        </v-tabs-items>

                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="hideModal">Annuler</v-btn>
                <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" @click="addAvis" dark>Ajouter</v-btn>
                </v-card-actions>
            </v-card>
</template>

<script>
export default {
    //name: "newAvis",
    props: ['currentDossier'],
    data: () => ({
    myvar: '',
    tab: null,
    itemsTabs: [
        'GENERAL', 'CARGO', 'COSTS',
    ],
    snackbar: false,
    snackbarText: '',
    tree: null,
    color: "success",
    textTabs: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    items: [
        {
          id: 1,
          name: 'Préstations',
          children: [],
        },
        {
          id: 5,
          name: 'Fret',
          children: [],
        },
      ],
    valid: false,
    model: 1,
    editedItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0,
      },
    filterSelectbox: ['Tous','Import', 'Export'],
    searchPrest: '',
    expanded: [],
    
    drawerClass: '',
    info: null,
    row: 'import',
    dialog: false,
    businessCompanies: [
      {
        title: 'Import'
      },
      {
        title: 'Export'
      },
    ],
    desserts: [],
    headers: [
        {
        text: 'N°Dossier',
        sortable: false,
        value: 'numdossier',
        },
        { 
        text: 'Type', 
        value: 'type'
        },
        { text: 'Navire', value: 'navire' },
        { text: 'Voyage', value: 'voyage' },
        { text: 'Date d\'arrivée', value: 'from_date' },
        { text: 'Date de sortie', value: 'to_date' },
        { text: 'Escale', value: 'escale' },
        { text: 'Armateur', value: 'armateur' },
        { text: 'Port de chargement', value: 'port_from' },
        { text: 'Port de déchargement', value: 'port_to' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],
    todayDate: ("0"+new Date().getDate()).slice(-2)+'/'+("0"+(new Date().getMonth()+1)).slice(-2)+'/'+new Date().getFullYear(),
    todayDateSql: new Date().getFullYear()+'/'+("0"+(new Date().getMonth()+1)).slice(-2)+'/'+("0"+new Date().getDate()).slice(-2),
    infoRules: [
        v => !!v || 'Veuillez saisir une valeur',
    ],
    headersAvis: [
      {
        text: 'N°BL',
        sortable: false,
        value: 'nbl',
      },
      { text: 'Client / Armateur', value: 'client' },
      { text: 'N°Avis', value: 'numavis' },
      { text: 'Facture Import', value: 'factureimport' },
      { text: 'Correspondant', value: 'correspondant' },
      { text: 'Fournisseur', value: 'fournisseur' },
      { text: 'Nbre colis', value: 'nbrecolis' },
      { text: 'Poids', value: 'poids' },
      { text: 'Actions', value: 'actions', sortable: false },
    ],
    headersMarchandises: [
        { text: 'Rub.', value: 'rub' },
        { text: 'Cont.Numéro', value: 'cont_numero' },
        { text: 'Cont.Type', value: 'conttype' },
        { text: 'Colis', value: 'colis' },
        { text: 'Description marchandise', value: 'description' },
        { text: 'Poids (Kg)', value: 'poids' },
        { text: 'Actions', value: 'actions' },
    ],
    headersMarchandisesAerien: [
        { text: 'Rub.', value: 'rub' },
        { text: 'Colis', value: 'colis' },
        { text: 'Description marchandise', value: 'description' },
        { text: 'Poids (Kg)', value: 'poids' },
        { text: 'Actions', value: 'actions' },
    ],
    headersMarchandisesGroupage: [
        { text: 'Rub.', value: 'rub' },
        { text: 'Colis', value: 'colis' },
        { text: 'Description marchandise', value: 'description' },
        { text: 'Poids (Kg)', value: 'poids' },
        { text: 'Volume', value: 'volume' },
        { text: 'Actions', value: 'actions' },
    ],
    marchandises: [],
    headersPrestations: [
        {
        text: 'Code',
        align: 'start',
        sortable: false,
        value: 'code_prestation',
        },
        { text: 'Description des prestations', value: 'description' },
        { text: 'TVA %', value: 'tva' },
        { text: 'Montant TVA', value: 'montantTva'},
        { text: 'Mnt Devise', value: 'montantDevise' },
        { text: 'Devise', value: 'devise' },
        { text: 'Cours', value: 'cour' },
        { text: 'Montant', value: 'montant' },
        { text: 'Actions', value: 'actions' },
    ],
    prestations: [],
    marchandiseTmp: {
        conttype: null,
        rub: '',
        cont_numero: null,
        colis: '',
        description: '',
        poids: '',
        volume: null
    },
    avisTmp: {
        timbre: 1,
        dossier_id: 0,
        num_avis: '',
        pc: '',
        terme: '',
        expediteur: '',
        agent_id : '',
        correspondant_id: '',
        client_id: '',
        bl: '',
        expediteur: '',
        code_magasin: '',
        valeur: '',
        bureau: ''
    },
    consigList: [],
    conteneurList: [],
    correspondantList: [],
    agentList: [],
    agent: '',
    correspondant: '',
    totalnt: 0,
    totalt: 0,
    totaltva: 0,
    total: 0,
    avisTmpData: {},
    clients: [],
    prestListTmp: []
  }),
  watch: {
    prestations: {
      deep: true,
      handler: 'calculate'
    },
    'avisTmp.timbre': function () {
        this.calculate()
    }
  },
    created() {
        this.axios
            .get('getPermissionByCredentials/'+this.$store.getters.getUser)
            .then(response => {
                if(response.data.data.indexOf('add_avis') === -1){
                    this.$router.push({name: 'notAllowed'})
                }
            })
    },
    mounted () {
            this.axios
            .get('/avis/listing')
            .then(response => (this.setAvisNumber(response.data)))

            this.axios
            .get('/correspondant/listing')
            .then(response => (this.correspondantList = response.data))

            this.axios
            .get('/agent/listing')
            .then(response => (this.agentList = response.data))

            this.axios
            .get('/conteneur/listing')
            .then(response => (this.conteneurList = response.data))

            this.axios
            .get('/client/listing')
            .then(response => (this.clients = response.data))

            this.axios
            .get('/prestation/listing')
            .then(response => {
                    var prestList = response.data
                    function compare(a, b) {
                        // Use toUpperCase() to ignore character casing
                        const A = a.type_prestation;
                        const B = b.type_prestation;

                        let comparison = 0;
                        if (A < B) {
                            comparison = 1;
                        } else if (A > B) {
                            comparison = -1;
                        }
                        return comparison;
                    }
                    prestList.sort(compare)
                    prestList.forEach((item, index) => {
                        if(item.impoexpo === this.currentDossier.type){
                            //item.id = index+1
                            item.name = item.description
                            item.prestation = item
                            if(item.cour === null){
                                item.cour = 0
                            }
                            if(item.montantDevise === null){
                                item.montantDevise = 0
                            }
                            if(item.type_prestation === 'Préstation'){
                                this.items[0].children.push(item)
                            }else{
                                this.items[1].children.push(item)
                            }
                        }
                    })
                }
            )
        
        },
  methods: {
    setAvisNumber(avis){
        if(avis.length > 0){
            var nextCode = avis.reduce((max, p) => p.num_avis > max ? p.num_avis : max, avis[0].num_avis)
            if(Number(nextCode.slice(0, 4)) === new Date().getFullYear() ) {
                nextCode = Number(nextCode)+1;
            }else{
                nextCode = new Date().getFullYear()+'0001'
            }
        }else{
            nextCode = new Date().getFullYear()+'0001'
        }
        this.avisTmp.num_avis = nextCode
        this.avisTmp.dossier_id = this.currentDossier.id
        

    },
    selectPrest(code, key){
        this.axios
            .get('/prestation/listing')
            .then(response => {
                var result = response.data.filter(obj => {
                return obj.code_prestation === code
                })[0]
                if(this.prestations.filter(obj => obj.code_prestation === result.code_prestation).length > 0){
                    this.color = "error"
                    this.snackbar = true
                    this.snackbarText = "Cette préstation est déjà insérée."
                }else{
                    if(!key)
                        key = 0
                    result.key = key+1
                    this.prestations.push(result)
                }
            }
        )
    },
    calculate(){
        this.totalnt = 0
        this.totalt = 0
        this.totaltva = 0
        this.total = 0
        this.prestations.forEach((item , index) => {
            item.cour = Number(item.cour)
            item.montant = Number(item.montant)
            item.montantDevise = Number(item.montantDevise)
            item.tva = Number(item.tva)
            if(item.cour > 0){
                this.prestations[index].montant = item.cour * item.montantDevise
            } 
            if(item.tva === 0){
                this.totalnt = item.montant + this.totalnt
            }else{
                this.totaltva = item.montant * item.tva / 100  + this.totaltva
                this.totalt = item.montant + this.totalt
            }
            item.montantTva = Number(item.montant.toFixed(3)) * item.tva / 100
        })
        this.total = Number(this.total.toFixed(3)) + Number(this.totalnt.toFixed(3)) + Number(this.totalt.toFixed(3)) + Number(this.totaltva.toFixed(3)) + Number(Number(this.avisTmp.timbre).toFixed(3))
    },
    addMarchandise(){
        if(this.currentDossier.classe == 'Complet'){
            this.marchandiseTmp.cont_type_id = this.conteneurList.filter(obj => {
                return obj.titre === this.marchandiseTmp.conttype
            })[0].id
        }
        this.marchandises.push(this.marchandiseTmp)
        this.marchandiseTmp = {}
                    
    },
    updateMarchandiseContType(item){
        console.log(this.marchandises.indexOf(item))
        const index = this.marchandises.indexOf(item)
        this.marchandises[index].cont_type_id = this.conteneurList.filter(obj => {
              return obj.titre === this.marchandises[index].conttype
            })[0].id
    },
    deleteMarchandises (item) {
        const index = this.marchandises.indexOf(item)
        confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.marchandises.splice(index, 1)
    },
    deletePrestation (item) {
        const index = this.prestations.indexOf(item)
        confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.prestations.splice(index, 1)
    },
    hideModal() {
        this.$emit('hide');
    },
    addAvis(){
        if(this.valid === false){
            this.color = "error"
            this.snackbar = true
            this.snackbarText = "Veuillez remplir tous les champs obligatoires."
        }else{
            this.avisTmpData.generals = {
                num_avis: this.avisTmp.num_avis,
                dossier_id: this.currentDossier.id,
                bl: this.avisTmp.bl,
                date: this.todayDateSql,
                correspondant_id: this.avisTmp.correspondant_id,
                agent_id: this.avisTmp.agent_id,
                pc: this.avisTmp.pc,
                terme: this.avisTmp.terme,
                fournisseur: this.avisTmp.fournisseur,
                client_id: this.avisTmp.client_id,
                bureau: this.avisTmp.bureau,
                code_magasin: this.avisTmp.code_magasin,
                valeur: this.avisTmp.valeur,
                timbre: this.avisTmp.timbre
            }
            this.avisTmpData.prestations = []
            this.avisTmpData.marchandise = []
            this.prestations.forEach((item, index) => {
                delete item.prestation
                delete item.name
                delete item.id
                delete item.datetime
                delete item.montantTva
                delete item.key
                this.avisTmpData.prestations.push(item)
            })
            this.marchandises.forEach((item, index) => {
                delete item.conttype
                this.avisTmpData.marchandise.push(item)
            })
            this.axios.post('/avis/create', this.avisTmpData, {
            }).then((res) => {
                if(res.data === 'error'){
                this.color = "error"
                this.snackbarText = "Essayez de remplir tous les champs obligatoires."
                this.snackbar = true
                }else{
                this.color = "success"
                this.snackbarText = "L'avis a été ajouté avec succès."
                this.snackbar = true
                this.$emit('reloadData')
                setTimeout( () => this.hideModal(), 1000)
                }
            }).catch(e => {
                this.color = "error"
                this.snackbar = true
                this.snackbarText = "Un erreur est survenu, essayez plus tard."
                console.log(e)
            })
        }
    },
  }
}
</script>
<style scoped>
.v-card__actions{
    position: absolute;
    bottom: 0;
    right: 0;
}
.avis-tab.v-tab:before{
    border-radius: 10px 50px 0 0;
}
.avis-tab.v-tab{
    background: #ebebeb;
    border-top-right-radius: 50px;
    border-top-left-radius: 15px;
    color: white;
}
.avis-tab.v-tab--active{
    border-top-right-radius: 50px;
    border-top-left-radius: 15px;
    color: white;
    background: linear-gradient(90deg, rgb(13, 74, 186) 0%, rgb(9, 155, 223) 100%);
}
.v-input >>> .v-input__slot{
    box-shadow:0  10px 15px rgba(0,0,0,0.05);
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/dossier/avis/new.component.vue